
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 600 201"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#000","d":"M377.61 99.29v51.06h-34.79V.05h53.63c15.5.59 29.22 5.16 39.34 17.26 23.25 27.79 10.4 72.2-25.55 80.43-10.73 2.46-21.7 1.3-32.63 1.56zm0-30.92c9.77-.45 20.27 2.02 28.31-4.91s7.73-20.8-.12-27.46c-7.89-6.69-18.67-4.39-28.19-4.79zM35.03 99.29v51.06H.24V.05h53.63c17.65.69 32.46 6.63 42.48 21.54 18.73 27.88 5.26 67.55-27.74 75.9-11 2.79-22.34 1.52-33.59 1.8zm0-30.92c9.81-.43 20.59 2.03 28.55-5.15 7.46-6.73 7.34-20.92-.48-27.33s-18.59-4.3-28.07-4.67v37.16z"}}),_c('path',{attrs:{"fill":"#000","d":"M177.77 59.26v-8.63h30.11l.36.36v99.36h-30.47v-8.39c-6.28 5.77-14.39 10.11-22.95 11.23-43.81 5.74-69.68-43.93-49.15-80.27 14.47-25.61 49.7-34.9 72.1-13.66m-26.2 18.77c-23.69 2.2-25.15 39.82-2.35 44.64 16.57 3.5 28.29-9.55 26.36-25.62-1.5-12.49-11.56-20.17-24.01-19.02M521.79 59.02v-8.03l.36-.36h30.11v99.72h-30.47v-8.39c-6.19 5.83-14.42 10.11-22.95 11.23-30.83 4.04-55.23-20.72-56.23-50.65-.9-26.96 17.39-51.91 45-54.78 12.78-1.33 24.77 2.66 34.18 11.26m-26.2 19.01c-21.97 2.11-25.19 35.48-5.79 43.52 12.59 5.22 26.84-1.83 29.48-15.3 3.1-15.81-6.87-29.84-23.69-28.22M336.35 50.63l-74.61 150.3h-35.03l34.05-68.68-45.81-81.62h37.55l25.91 47.94 23.27-47.94zM599.04 150.11h-34.31V.41l.36-.36h33.59l.36.36z"}})])
          )
        }
      }
    